import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import "../../Styles/Admin.scss";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import MyCommandCell from "./myCommandCell.jsx";
import { CircularProgress } from "@material-ui/core";
import { toastr } from "react-redux-toastr";
import Api from "../../Services/Api";
import { Popup } from "@progress/kendo-react-popup";
class ActionType extends Component {
  editField = "inEdit";
  currentComponent = "projectStage";
    state = {
      data: [],
      loader: false,
      skip: 0,
      take: 10,
      delete: false,
       };
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };

  componentDidMount() {
    this.getProjectStage();
  }
  getProjectStage = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      let response = await Api.getProjectStage();
      if (response.status === 200 && response.actionTypes) {
        this.setState({ ...this.state, loader: false });
        this.setState({ data: response.actionTypes });
      } else {
        this.setState({ ...this.state, loader: false });
        this.setState({ data: [] });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  CommandCell = (props) => (
    <MyCommandCell
      {...props}
      edit={this.enterEdit}
      handledelete={this.handledelete}
      add={this.add}
      discard={this.discard}
      update={this.update}
      cancel={this.cancel}
      editField={this.editField}
      currentComponent={this.currentComponent}
    />
  );

  discard = (dataItem) => {
    const data = [...this.state.data];
    data.splice(0, 1);
    this.setState({ data });
  };
  handledelete= (dataItem)=>{
    this.setState({
      delete:!this.state.delete,
      actionId: dataItem.actionId,
    })
  }
  handleclose=()=>{
    this.setState({
      delete:!this.state.delete,
      actionId:0,
    })
  }
  // modify the data in the store, db etc
  remove = async () => {
    try {
      let loggedClient = secureLocalStorage.getItem("loggedClient");
      let createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      let requestParams = {
        actionId: this.state.actionId,
        DeletedBy: parseInt(createdby),
      };

      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteProjectStage(requestParams);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.getProjectStage();
        this.setState({
          delete:false,
        })
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  add = async (dataItem) => {
    if (!dataItem.name || dataItem.name.trim() == "") {
      toastr.error("Stage is required");
      return;
    } else {
      try {
        let requestParams = {
          Name: dataItem.name.trim(),
        };
        this.setState({ ...this.state, loader: true });
        let response = await Api.addProjectStage(requestParams);
        if (response.status === 200) {
          this.setState({ ...this.state, loader: false });
          toastr.success(response.message);
          this.getProjectStage();
        } else {
          toastr.error(response.message);
          this.setState({ ...this.state, loader: false });
        }
      } catch (error) {
        this.setState({ ...this.state, loader: false });
        console.error(error);
      }
    }
  };

  update = async (dataItem) => {
    if (!dataItem.name || dataItem.name.trim() == "") {
      toastr.error("Stage is required");
      return;
    } else {
      try {
        dataItem.inEdit = false;
        let loggedClient = secureLocalStorage.getItem("loggedClient");
        let createdby =
          loggedClient == "user"
            ? secureLocalStorage.getItem("userId")
            : secureLocalStorage.getItem("tenantId");
        let requestParams = {
          Name: dataItem.name.trim(),
          actionId: dataItem.actionId,
          UpdatedBy: parseInt(createdby),
        };
        this.setState({ ...this.state, loader: true });
        let response = await Api.updateProjectStage(requestParams);
        if (response.status === 200) {
          this.setState({ ...this.state, loader: false });
          toastr.success(response.message);
          this.getProjectStage();
        } else {
          toastr.error(response.message);
          this.setState({ ...this.state, loader: false });
        }
      } catch (error) {
        this.setState({ ...this.state, loader: false });
        console.error(error);
      }
    }
  };

  cancel = (dataItem) => {
    this.getProjectStage();
  };

  enterEdit = (dataItem) => {
    const dataValue = this.state.data.map((item) => ({
      ...item,
      inEdit: item.actionId === dataItem.actionId ? true : false,
    }));
    this.setState({
      data: dataValue,
    });
  };

  itemChange = (event) => {
    const data = this.state.data.map((item) =>
      item.actionId === event.dataItem.actionId
        ? { ...item, [event.field]: event.value }
        : item
    );

    this.setState({ data });
  };

  addNew = () => {
    const newDataItem = { inEdit: true, Discontinued: false };

    this.setState({
      data: [newDataItem, ...this.state.data],
      skip: 0,
      take: 10,
    });
  };
  render() {
    return (
      <div className="riskTypeCont">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
         {this.state.delete ===true ?(
                <Popup
                show={this.state.delete}
                popupClass={"popup-content"} >
                  <div className="deleteModelCont">
            <h3>Are you sure you want to delete this Action Type?</h3>
            <div className="btnCont">
              <button 
              onClick={this.remove} 
              className="deleteBtn">
                Delete
              </button>
              <button
               onClick={this.handleclose} 
               className="cancelBtn">
                Cancel
              </button>
            </div>
          </div>
          </Popup>):null
                }
        <div className="dbCard card100 noPadd">
          <div className="gridBox">
            <div className="tblCont dataGrids noPaddTop">
              <div className="rw-tab-content">
                <Grid
                  data={this.state.data.slice(
                    this.state.skip,
                    this.state.take + this.state.skip
                  )}
                  onItemChange={this.itemChange}
                  editField={this.editField}
                  pageable={true}
                  skip={this.state.skip}
                  take={this.state.take}
                  total={this.state.data.length}
                  onPageChange={this.pageChange}
                >
                  <GridToolbar className="customHeader">
                    <div className="gridHeader">
                      <div className="d-flex align-items-center">
                        <h4>Action Type</h4>
                        <div className="ml-auto d-flex">
                          <div className="btnGreen noMargin">
                            <button onClick={this.addNew}>Add Type</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </GridToolbar>
                  <Column field="name" title="Type" />

                  <Column cell={this.CommandCell} width="100px" title="Actions" />
                </Grid>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ActionType;
